import styled from "styled-components";
import { apolloLineHeightButtonLabel, apolloSpaceInset1HalfX, apolloSpaceInset1X, apolloSpaceInset3X, } from "@nexthink/apollo-tokens";
import Flex from "../box/Flex";
import { getValueFromPixelString } from "../../utils/TokenHelpers";
import { MAIN_NAV_WIDTH } from "../main-container/MainContainer.style";
// standard button height + 2 * padding
export const BOTTOM_BAR_HEIGHT = `calc(${apolloLineHeightButtonLabel} + ${2 * (getValueFromPixelString(apolloSpaceInset1HalfX) + getValueFromPixelString(apolloSpaceInset1X))}px)`;
export const StyledBottomBarContainer = styled(Flex).attrs({ forwardedAs: "footer" }).withConfig({ displayName: "StyledBottomBarContainer_APC-7281-productShell", componentId: "sc-1k44i96" })(({ theme, position }) => ({
    alignItems: "center",
    background: theme.colors.apolloColorBackgroundContainer,
    bottom: 0,
    boxShadow: theme.colors.apolloBoxShadowSeparatorTop,
    display: "inline-flex",
    height: BOTTOM_BAR_HEIGHT,
    left: position === "fixed" ? MAIN_NAV_WIDTH : 0,
    padding: `${apolloSpaceInset1X} ${apolloSpaceInset3X}`,
    position,
    right: 0,
    gap: `${apolloSpaceInset1X}`,
}));
//# sourceMappingURL=BottomBar.style.js.map